import React from 'react';
import PropTypes from 'prop-types';

const SatRadio = props => {
  const {
    options,
    value = options[0].value,
    customStyleClass,
    type = 'left ',
    disabled = false,
    onChange,
    onValidNotiModal = undefined,
    name,
    locked,
  } = props;

  const handleRadio = option => {
    onChange(option);
  };

  const getClassName = () => {
    let className = 'type-';

    if (customStyleClass) {
      className = customStyleClass;
    } else {
      // type
      className += type === 'button' ? 'btn ' : type;
    }

    // 잠금 아이콘
    if (locked) {
      className += 'locked ';
    }

    return className;
  };

  return (
    <>
      {options.map(option => {
        return (
          <div
            key={option.value}
            className={`check-wrap ${getClassName()}`}
            onClick={() => {
              if (!disabled) {
                if (!option.disabled) {
                  handleRadio(option);
                } else {
                  if (
                    onValidNotiModal &&
                    typeof onValidNotiModal === 'function'
                  ) {
                    onValidNotiModal();
                  }
                }
              } else {
                if (
                  onValidNotiModal &&
                  typeof onValidNotiModal === 'function'
                ) {
                  onValidNotiModal();
                }
              }
            }}
          >
            <input
              type="radio"
              value={option.value}
              name={name ? name : 'radio'}
              checked={value === option.value}
              disabled={disabled ? true : option.disabled || false}
              onChange={() => console.log('')}
            />
            <label>{option.label}</label>
          </div>
        );
      })}
    </>
  );
};

SatRadio.propTypes = {
  /**
   * options
   */
  options: PropTypes.array,
  /**
   * 입력 값
   */
  // value: PropTypes.string,
  /**
   * radio 타입
   */
  type: PropTypes.oneOf(['left', 'right', 'button']),
  /**
   * radio disabled
   */
  disabled: PropTypes.bool,
  /**
   * 사용자 radio 선택 값 callback event
   */
  onChange: PropTypes.func,
  /**
   * disabled 시 알림을 위한 callback event
   */
  onValidNotiModal: PropTypes.func,
};

SatRadio.defaultProps = {
  options: [],
  value: '',
  type: 'left',
  disabled: false,
  onChange: undefined,
  onValidNotiModal: undefined,
};

export default SatRadio;
